export default class TreeCounter extends HTMLElement {
  constructor() {
    super();
    this.fetchTreeCounter();
  }

  async fetchTreeCounter() {
    const fetchURL = window.theme.routes.treeCounter;
    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
    };

    await fetch(fetchURL, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.innerHTML = Number(data.n_trees_requested__sum).toLocaleString();
      })
      .catch((err) => {
        console.error("error retrieving data", err);
      });
  }
}

customElements.define('tree-counter', TreeCounter);
